import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Resource
export function getViewManageResources(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-resources`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathResources(resourceId=null) {
  if (resourceId) {
      return `resources/${resourceId}`;
  } else {
      return `resources`;
  }
}

export function createResources(successCallback, errorCallback, data) {
  postAuth({
    "path": pathResources(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchResources(successCallback, errorCallback, data, resourceId) {
  patchAuth({
    "path": pathResources(resourceId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteResources(successCallback, errorCallback, resourceId) {
  deleteAuth({
    "path": pathResources(resourceId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postUpdateResourceDistinctProperties(successCallback, errorCallback, data, resourceId) {
  postAuth({
    "path": `resources/${resourceId}/update-distinct-properties`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postPurgeResourceRecords(successCallback, errorCallback, resourceId) {
  postAuth({
    "path": `resources/${resourceId}/purge-records`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export const URL_RESOURCE_ICON_MEDIA = `/${constants.API_VERSION}/resources/icon-media`;

// Resource Properties
export function getViewManageResourceProperties(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-resource-properties`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathResourceProptypes(proptypeId=null) {
  if (proptypeId) {
      return `resource-property-types/${proptypeId}`;
  } else {
      return `resource-property-types`;
  }
}

export function createResourceProptypes(successCallback, errorCallback, data) {
  postAuth({
    "path": pathResourceProptypes(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchResourceProptypes(successCallback, errorCallback, data, proptypeId) {
  patchAuth({
    "path": pathResourceProptypes(proptypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteResourceProptypes(successCallback, errorCallback, proptypeId) {
  deleteAuth({
    "path": pathResourceProptypes(proptypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Resource Records
export function getViewManageResourceRecords(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-resource-records`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathResourceRecords(recordId=null) {
  if (recordId) {
      return `resource-records/${recordId}`;
  } else {
      return `resource-records`;
  }
}

export function createResourceRecords(successCallback, errorCallback, data) {
  postAuth({
    "path": pathResourceRecords(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchResourceRecords(successCallback, errorCallback, data, recordId) {
  patchAuth({
    "path": pathResourceRecords(recordId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteResourceRecords(successCallback, errorCallback, recordId, qs={}) {
  deleteAuth({
    "path": urlUtils.appendQueryString(pathResourceRecords(recordId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Associations
export function getViewManageResourceAssociations(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-resource-associations`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathResourceAssociations(associationId=null) {
  if (associationId) {
      return `resource-associations/${associationId}`;
  } else {
      return `resource-associations`;
  }
}

export function createResourceAssociations(successCallback, errorCallback, data) {
  postAuth({
    "path": pathResourceAssociations(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchResourceAssociations(successCallback, errorCallback, data, associationId) {
  patchAuth({
    "path": pathResourceAssociations(associationId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteResourceAssociations(successCallback, errorCallback, associationId) {
  deleteAuth({
    "path": pathResourceAssociations(associationId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Association Records
export function getViewManageResourceAssociationRecords(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-resource-association-records`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathResourceAssociationRecords(recordId=null) {
  if (recordId) {
      return `resource-association-records/${recordId}`;
  } else {
      return `resource-association-records`;
  }
}

export function createResourceAssociationRecords(successCallback, errorCallback, data) {
  postAuth({
    "path": pathResourceAssociationRecords(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteResourceAssociationRecords(successCallback, errorCallback, recordId) {
  deleteAuth({
    "path": pathResourceAssociationRecords(recordId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
